import { render, staticRenderFns } from "./TabModules.vue?vue&type=template&id=26e6e8e1&scoped=true"
import script from "./TabModules.vue?vue&type=script&lang=js"
export * from "./TabModules.vue?vue&type=script&lang=js"
import style0 from "./TabModules.vue?vue&type=style&index=0&id=26e6e8e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e6e8e1",
  null
  
)

export default component.exports